import { render, staticRenderFns } from "./myAIGkWeapon.vue?vue&type=template&id=29d11104&scoped=true&"
import script from "./myAIGkWeapon.vue?vue&type=script&lang=js&"
export * from "./myAIGkWeapon.vue?vue&type=script&lang=js&"
import style0 from "./myAIGkWeapon.vue?vue&type=style&index=0&id=29d11104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d11104",
  null
  
)

export default component.exports